import React, {Fragment} from 'react'
import { Button } from '@drifthq/tide-core'

import Snippet from 'layouts/Snippet'

import './style.css'

const InstallWordpress = ({
  snippet,
  onContinueClick,
}) => (
  <Fragment>
    <ol className="install-wordpress-list">
      <li>
        <p className="install-exp-snippet-description">
          <a className="touchless-wordpress-install-wrapper-a" href="https://wordpress.org/plugins/drift/" target="_blank" rel="noopener noreferrer">Download the Drift Wordpress plugin</a> and add it to your site
        </p>
      </li>
      <li>
        <p className="install-exp-snippet-description">
          Copy the code below and go to your WordPress Admin panel. You should see a link to Drift in your dashboard. Click Settings > Drift > and then paste this code in the field.
        </p>
        <Snippet snippet={snippet} className="install-wordpress-snippet"/>
      </li>
    </ol>
    <p className="install-exp-docs-wordpress">
      Identify visitors on your site. <a className="touchless-install-snippet-wrapper-a" href="https://help.drift.com/article/install-drift-on-your-website-javascript/" target="_blank" rel="noopener noreferrer">Learn more</a>
    </p>
    <Button onClick={onContinueClick}>Verify Installation</Button>
  </Fragment>
)

export default InstallWordpress


// WEBPACK FOOTER //
// ./src/layouts/InstallWordpress/component.js